import { createContext } from 'react';
import type { RoleToken } from './types';

/** "View as role" state for the tree (see `role-preview.ts`). */
export interface RolePreviewValue {
  /** The role being previewed, or null when the console shows the
   *  person's own roles. */
  readonly previewRole: RoleToken | null;
  /** The signed-in person's REAL roles, whatever is being previewed.
   *  The only things that should read these are the preview machinery
   *  itself and what asks which reads the REAL token may make (the plan
   *  check's request, `usePlanCheckAccess`): every other role decision
   *  must use `useAuth().roles`. */
  readonly realRoles: readonly RoleToken[];
  /** Roles this person may preview; empty when they may not preview. */
  readonly choices: readonly RoleToken[];
  readonly enterPreview: (role: RoleToken) => void;
  readonly exitPreview: () => void;
}

export const RolePreviewContext = createContext<RolePreviewValue | null>(null);
